/**
 * Răspuns pentru GET /dashboard/port-transit-times.
 * Calculat din bookings finalizate (onBoardDate → dischargeDate).
 */
export interface PortTransitTimeRow {
  polCode: string;
  polName: string;
  podCode: string;
  podName: string;
  averageTransitTime: number;
  bookingsCount: number;
  containersCount: number;
}

export const EMPTY_PORT_TRANSIT_TIMES: PortTransitTimeRow[] = [];
